import './style/main.scss'
import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client'

import App from './components/App'
import Error from './components/Error'

import { polyfillLoader } from 'polyfill-io-feature-detection'
import apolloClient from './apolloClient'

import dayjs from 'dayjs'
import 'dayjs/locale/nl'

dayjs.locale('nl')

polyfillLoader({
  features: 'Promise,fetch',
  onCompleted: main
})

function main () {
  ReactDOM.render(
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>,
    document.getElementById('root')
  )
}
